import axios from "axios";
import store from "../../Redux/store";
import { HEADERS} from "../UrlAndPaths";
import { get_cash_inor_out_details, setCashInOrOutDialog } from "../../Redux/Dashboard/cashInOrOutSlice";
import { setSubmitLoading } from "../../Redux/Dashboard/mainDashBoardSlice";
import { setErrorSnack, setSnackMsg, setSuccessSnack } from "../../component/Modules/Sales/Billing/Slice/billingScreenSlice";


/// add cash in or out api cal
export const addCashInOrOutAPICall=(body,cancelFn)=>{
    store.dispatch(setSubmitLoading(true))
    axios.post("settings/addcashinorout",body,HEADERS)
    .then((res)=>{
        if(res.status===200){

            viewCashInOrCashOutAPICall()
            store.dispatch(setSubmitLoading(false))
            store.dispatch(setCashInOrOutDialog(false))
            store.dispatch(setSnackMsg("Success"))
            store.dispatch(setSuccessSnack(true))

            cancelFn()
        }
    })
    .catch((err)=>{
        store.dispatch(setSubmitLoading(false))
        store.dispatch(setSnackMsg(err.response.status===500?"Internal server error !":err.response.data))
        store.dispatch(setErrorSnack(true))
    })
}

// view cash in or out api call
export const viewCashInOrCashOutAPICall=()=>{
    axios.post("settings/listcashinorout",{},HEADERS)
    .then((res)=>{
        if(res.status===200){
          store.dispatch(get_cash_inor_out_details({cashInOrOutData:res.data}))
        }
    })
    .catch((err)=>{
        store.dispatch(get_cash_inor_out_details({cashInOrOutData:undefined}))
        console.log(err.response);
    })
}